import { render, staticRenderFns } from "./booking-counts.vue?vue&type=template&id=68a96a80&scoped=true"
import script from "./booking-counts.vue?vue&type=script&lang=js"
export * from "./booking-counts.vue?vue&type=script&lang=js"
import style0 from "./booking-counts.vue?vue&type=style&index=0&id=68a96a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a96a80",
  null
  
)

export default component.exports